
<template>  
    <router-view />  
</template>




<script>
    import "/node_modules/flag-icons/css/flag-icons.min.css";
   export default {
      name: "App",
    
    }
</script>



<style lang="scss">
    
    @use "scss";

    // .lista {
    //     list-style: none;
    //     font-size: 22px;
    // }

    // .lista li {
    //     margin-bottom: 5px;
    //     padding-left: 20px;
    //     position: relative;
    //     cursor: pointer;
    //     width: 200px;
    // }

    // .lista li a {
    //     color: inherit;
    //     text-decoration: none;
    // }

    // .lista li:hover {
    //      background-color: #2e73b080;  
    //     transition: all 0.3s ease;   

    // }

</style>



